export const SET_CARD_READER_PENDING_REQUEST = 'setCardReaderPendingRequest'
